<div class="tags">
  {{'system.tags' | translate}}:
  <ng-container *ngFor="let tag of tags; let last = last">
    <span (click)="searchTag(tag)">{{tag.title}}</span>{{last ? '' : ', '}}
  </ng-container>
  <app-spinner *ngIf="showSpinner" [strokeWidth]="2" [diameter]="15"></app-spinner>
</div>
